// TEMPORARY — partner system-migration notice. Remove after 03-10-2026.
// Shown once on the partner sign-in screen to tell partners from the previous
// system that they may need to register again. Self-expires via NOTICE_EXPIRY
// (stops rendering from that date even if this file is never deleted), and a
// dismissal is remembered in localStorage so returning partners aren't nagged.
import { useState } from 'react';
import ModalShell from '../../components/shared/ModalShell';

const NOTICE_EXPIRY = new Date('2026-10-03T00:00:00');
const DISMISSED_KEY = 'ag_partner_migration_notice_dismissed';

function wasDismissed() {
  // localStorage can throw (private mode / blocked storage) — treat as dismissed
  // so a storage failure never traps the partner behind an undismissable modal.
  try {
    return localStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return true;
  }
}

export default function PartnerMigrationNotice() {
  const [open, setOpen] = useState(() => new Date() < NOTICE_EXPIRY && !wasDismissed());

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // Storage unavailable — the modal still closes for this visit.
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <ModalShell ariaLabel="We've moved to a new system" onClose={dismiss}>
      <div className="flex items-center gap-3 mb-4 w-full max-w-[180px]">
        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-[rgba(212,168,67,0.4)]" />
        <div className="w-1.5 h-1.5 rotate-45 bg-[rgba(212,168,67,0.55)] shrink-0" />
        <div className="flex-1 h-px bg-gradient-to-l from-transparent to-[rgba(212,168,67,0.4)]" />
      </div>
      <h2 className="font-cormorant font-normal text-[1.8rem] leading-[1.1] tracking-[-0.01em] text-white mb-3">
        We&rsquo;ve moved to a new system
      </h2>
      <p className="font-dm-sans text-sm font-light text-white/60 leading-relaxed mb-4">
        Alfresco Grand has upgraded its partner booking platform. If you had an
        account on our previous system, you may need to register again to continue.
      </p>
      <p className="font-dm-sans text-sm font-light text-white/60 leading-relaxed mb-6">
        For help with your account, please call{' '}
        <a
          href="tel:+919435558001"
          className="font-medium text-[#D4A843] hover:text-[#C9A84C] transition-colors duration-300 whitespace-nowrap"
        >
          94355 58001
        </a>
        .
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="w-full py-[13px] bg-[#C9A84C] text-[#0A1628] font-dm-sans font-semibold text-[12.5px] tracking-[0.15em] uppercase rounded-full transition-[transform,background-color] duration-[160ms] ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97] hover:bg-[#B8973E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(201,168,76,0.5)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D1E35]"
      >
        Got it
      </button>
    </ModalShell>
  );
}
